let env = process.env.NODE_ENV;
// let env = development;

let _baseUrl = '';
let _vertifyImageUrl = '';

if (env === 'development') {
	_baseUrl = 'https://127.0.0.1:9007/';
	_vertifyImageUrl = 'https://127.0.0.1:9007/signUp/vertifyImage?flag=';
} else if (env === 'production') {
	_baseUrl = '//robinalgo.com:9007/';
	_vertifyImageUrl = '//robinalgo.com:9007/signUp/vertifyImage?flag=';
}


global.constants = {
    baseApi: _baseUrl,
    vertifyImageUrl: _vertifyImageUrl,
	env : env,
}